function isSalesman(store) {
  const { user } = store.state.auth
  return user?.jobTitle === 'Vendedor'
}

export default async function({ store, redirect }) {
  if (isSalesman(store)) {
    return redirect('/menu')
  }
}
